import axios from "axios";

import { InvoiceAdjustmentContent } from "./validation";

export interface AdjustInvoiceParams {
  invoiceId: number;
  data: InvoiceAdjustmentContent;
}

export const adjustInvoice = ({
  invoiceId,
  data: { reasonCodes, ...rest },
}: AdjustInvoiceParams) =>
  axios
    .post(
      `invoices/adjust`,
      {
        invoiceId,
        reasonIds: reasonCodes,
        ...rest,
      },
      {
        hideToast: true,
      }
    )
    .then((res) => res.data);

export default adjustInvoice;
